import { Grid } from '@mui/material';
import clsx from 'clsx';
import useScreenMessageStyles from './ScreenMessage.styles';

interface Props {
	alt: string;
	description: string | React.ReactElement;
	fullHeight?: boolean;
	fullWidth?: boolean;
	id: string;
	image: string;
	imageHeight?: string | number;
	imageWidth?: string | number;
	style?: React.CSSProperties;
	title: string | React.ReactElement;
}

const ScreenMessage: React.FC<Props> = ({
	alt,
	description,
	fullHeight,
	fullWidth,
	id,
	image,
	imageHeight,
	imageWidth,
	style,
	title,
}) => {
	const classes = useScreenMessageStyles();

	return (
		<Grid
			container
			alignItems="center"
			className={clsx(classes.root, {
				[classes.rootFullHeight]: fullHeight,
				[classes.rootFullWidth]: fullWidth,
			})}
			direction="column"
			id={id}
			justifyContent="center"
			spacing={3}
			style={style}
		>
			<Grid item>
				<img
					alt={alt}
					height={imageHeight}
					id={`${id}-image`}
					src={image}
					width={imageWidth}
				/>
			</Grid>
			<Grid item id={`${id}-content`}>
				<p className={classes.title} id={`${id}-content-title`}>
					{title}
				</p>
				<p className={classes.description} id={`${id}-content-description`}>
					{description}
				</p>
			</Grid>
		</Grid>
	);
};

export default ScreenMessage;
